import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISideBarNotification } from '@core/models';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable()
export class SideBarNotificationService {

  basePath: string;

  constructor(private readonly configService: ConfigService, private readonly httpClient: HttpClient) {
    this.basePath = this.configService.appConfig.api.uoUrl;
  }

  getNotificationList(): Promise<ISideBarNotification[]> {
    return firstValueFrom(this.httpClient.get<ISideBarNotification[]>(`${this.basePath}/notification/list`));
  }
}
